import { render } from "./MultiSelectInputWhatsappGroup.vue?vue&type=template&id=16815278"
import script from "./MultiSelectInputWhatsappGroup.vue?vue&type=script&lang=js"
export * from "./MultiSelectInputWhatsappGroup.vue?vue&type=script&lang=js"

import "./MultiSelectInputWhatsappGroup.vue?vue&type=style&index=0&id=16815278&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__